<script>
    import { GET, POST } from "../../components/communication.js";
    import {onMount} from "svelte";
    import { authToken, sessionStorageSet, sessionStorageRemove, flashErrorMessage, flashSuccessMessage }
        from "../../components/stores.js";
    import { navigate } from "svelte-routing";

    export let hash;
    let passwordsForm = { pass1: "",pass2: "", hash: ""}
    let disabled = true;

    // Ajetaan, kun sivulle tullaan
    onMount(async function () {
       passwordsForm.hash = hash;
    });

    async function handleSubmit(event) {
        sessionStorageRemove("authToken");
        authToken.set('');

        const response = POST("/C/newPassword", JSON.stringify(passwordsForm));
        const data = await response;

        if(data && data.error === undefined) {
            navigate('/kirjaudu', { replace: false });
            flashSuccessMessage.set("Uusi salasana on asetettu ja voi kirjautua järjestelmään.");
        } else {
            flashErrorMessage.set(data.error);
        }

    }

    let disabledClass = "disabled";
    function enableButtons(c) {
        if(c.pass1 === "" || c.pass2 === "" || c.pass1 != c.pass2 || c.pass1.length < 7) {
            disabled = true;
        } else {
            disabled = false;
        }

        if (disabled) {
            disabledClass = "disabled";
        } else {
            disabledClass = "";
        }
    }

</script>

<div class="page row">
    <div class="col-sm-12 col-md-6 col-lg-6" style="margin-left:auto;margin-right:auto;">
        <div class="card">
            <h5 class="card-header">Anna salasana kahdesti</h5>
            <div class="card-body">
                <p>Salasanassa on oltava vähintään 8 merkkiä.</p>
                <form on:submit|preventDefault={handleSubmit}>
                    <input type="hidden"
                           id="hash"
                           bind:value={passwordsForm.hash} />
                    <div class="form-group">
                        <label for="password1">Salasana</label>
                        <input class="form-control"
                               required
                               type="password"
                               id="password1"
                               bind:value={passwordsForm.pass1}
                               on:keyup={enableButtons(passwordsForm)}/>
                    </div>
                    <div class="form-group">
                        <label for="password2">Salasana uudestaan</label>
                        <input class="form-control"
                               required
                               type="password"
                               id="password2"
                               bind:value={passwordsForm.pass2}
                               on:keyup={enableButtons(passwordsForm)}/>
                    </div>
                    <button type="submit" class="btn btn-primary {disabledClass}" {disabled}>Vaihda salasana</button>
                </form>
            </div>
        </div>
    </div>
</div>
